
import React from 'react'
import { useState } from 'react'
import { Container, Wrapper, Title, Desc, CardContainer, ToggleButtonGroup, ToggleButton, Divider } from './BlogStyle'
import BlogCard from '../Cards/BlogCard'
import { blogs } from '../../data/constants'


const Blogs = ({openModal,setOpenModal}) => {
  return (
    <Container id="blogs">
      <Wrapper>
        <Title>Blogs</Title>
        <Desc>
            Explore my insightful blogs on Medium, where I share my thoughts on technology, machine learning, and the future of AI. Dive into detailed technical discussions, industry trends, and my personal take on innovations shaping the digital world.
        </Desc>
        <CardContainer>
          {blogs
            .map((blogs) => (
              <BlogCard project={blogs} openModal={openModal} setOpenModal={setOpenModal}/>
            ))}
        </CardContainer>
      </Wrapper>
    </Container>
  )
}

export default Blogs
